import NewRelicBrowser from 'new-relic-browser';

declare global {
  interface Window {
    newrelic: typeof NewRelicBrowser;
  }
}

export const newrelic = (typeof window !== 'undefined' ? window.newrelic : null) as typeof NewRelicBrowser;

export const noticeError = (err: any, parameters?: Record<string, string>) => {
  if (newrelic !== null) {
    if (process.env.NODE_ENV === 'development') {
      console.error(err, parameters);
    }
    // see https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/noticeerror-browser-agent-api/#browser-limits
    try {
      throw err;
    } catch (error) {
      newrelic.noticeError(err, parameters);
    }
  }
};
